(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-tf-popup]');
    if (!root) return;

    var delay = parseInt(root.getAttribute('data-delay'), 10) || 0;
    var showAgainValue = parseInt(root.getAttribute('data-show-again'), 10);
    var showAgain = isNaN(showAgainValue) ? 24 : showAgainValue; // hours; 0 = always
    var STORAGE_KEY = 'tf-popup-shown';
    var dialog = root.querySelector('[data-tf-popup-dialog]');
    var lastFocused = null;
    var timer = null;

    function shouldShow() {
      if (showAgain === 0) return true;
      try {
        var ts = localStorage.getItem(STORAGE_KEY);
        if (!ts) return true;
        return Date.now() - parseInt(ts, 10) >= showAgain * 3600 * 1000;
      } catch (e) {
        return true;
      }
    }

    function markShown() {
      try {
        localStorage.setItem(STORAGE_KEY, String(Date.now()));
      } catch (e) {}
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      var focusable = dialog.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function open() {
      if (root.classList.contains('is-open')) return;
      lastFocused = document.activeElement;
      root.style.display = 'block';
      root.setAttribute('aria-hidden', 'false');
      void root.offsetWidth; // force reflow so the transition runs
      root.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', trapFocus);
      var closeBtn = root.querySelector('.tf-popup__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', trapFocus);
      setTimeout(function () {
        root.style.display = 'none';
      }, 320);
      markShown();
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    root.querySelectorAll('[data-tf-popup-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    if (shouldShow()) {
      timer = setTimeout(open, delay * 1000);
    }

    // Always visible while editing the section in the theme editor
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target.contains(root)) {
          clearTimeout(timer);
          open();
        }
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target.contains(root)) close();
      });
    }

    window.TF_POPUP = window.TF_POPUP || {};
    window.TF_POPUP.open = open;
    window.TF_POPUP.close = close;
  })();

  } catch(e) { console.error(e); }
})();
})();
